import React from "react";
import { Tag } from "antd";
import { Link } from "react-router-dom";
import MapaRota from "../MapaRota";
import LinhaDoTempoFrete from "../LinhaDoTempoFrete";
import {
  marcacaoDoFrete,
  CORES_DA_MARCACAO,
  ROTULOS_DA_MARCACAO,
} from "../../util/freight/acompanhamento-marcacoes";

function PainelTempoReal({ frete }) {
  const marcacao = frete ? marcacaoDoFrete(frete) : null;

  return (
    <section className="painel-tempo-real">
      <h2 className="painel-tempo-real__titulo">
        Acompanhamento em tempo real
      </h2>

      <div className="painel-tempo-real__corpo">
        <MapaRota frete={frete} compacto />

        <div className="painel-tempo-real__lateral">
          {!frete ? (
            <p className="painel-tempo-real__vazio">
              Selecione um frete na lista para ver o trajeto e a linha do tempo.
            </p>
          ) : (
            <>
              <header className="painel-tempo-real__cabecalho">
                <strong>{frete.numberSerial ?? "—"}</strong>
                <span>· {frete?.driver?.name || "Não informado"}</span>
                <Tag color={CORES_DA_MARCACAO[marcacao]}>
                  {ROTULOS_DA_MARCACAO[marcacao]}
                </Tag>
              </header>

              <LinhaDoTempoFrete frete={frete} compacta />

              <Link
                className="painel-tempo-real__link"
                to={`/freightsDetail/${frete.id}/${frete?.driver?.uidDriver || ""}`}
              >
                Ver detalhes da entrega
              </Link>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default PainelTempoReal;
